import Vue from 'vue'

import Cursor from './cursor'

Vue.directive('cursor', {
  inserted (el) {
    return new Cursor(el)
  }
})
